import { hasPopulatedPermissionMap } from '../../assets/utils/permissions';

export const CARE_PROGRAM_DESIGNER_PERMISSIONS = [
  'admin.*',
  'care_programs.manage',
  'plans.manage',
];

export const CARE_PROGRAM_UTILIZATION_PERMISSIONS = [
  'admin.*',
  'care_programs.read_all_utilization',
  'corporations.view_reports',
  'enrollees.read_all',
];

export const ORG_CARE_PROGRAM_PERMISSIONS = [
  'admin.*',
  'care_programs.manage_org',
  'plans.manage',
];

export const BULK_UPLOAD_LOGS_PERMISSIONS = [
  'admin.*',
  'corporations.view_reports',
  'corporations.read_own',
];

export const LEGACY_CARE_PROGRAM_ROLES = [1, 5];

function permissionOk(hasAnyPermission, permissions) {
  if (typeof hasAnyPermission === 'function') {
    return hasAnyPermission(permissions);
  }
  return false;
}

/** Permission-first; LEGACY_CARE_PROGRAM_ROLES apply only on an empty permission map. */
function legacyFallback(user) {
  if (hasPopulatedPermissionMap(null, user)) return false;
  return LEGACY_CARE_PROGRAM_ROLES.includes(Number(user?.role?.staffRoleId));
}

export function canManageCarePrograms(user, hasAnyPermission, canStayOnModule) {
  if (typeof canStayOnModule === 'function') {
    return canStayOnModule('careProgramsDesigner', LEGACY_CARE_PROGRAM_ROLES);
  }
  if (permissionOk(hasAnyPermission, CARE_PROGRAM_DESIGNER_PERMISSIONS)) return true;
  return legacyFallback(user);
}

export function canViewCareProgramUtilization(user, hasAnyPermission, canStayOnModule) {
  if (typeof canStayOnModule === 'function') {
    return canStayOnModule('careProgramUtilization', LEGACY_CARE_PROGRAM_ROLES);
  }
  if (permissionOk(hasAnyPermission, CARE_PROGRAM_UTILIZATION_PERMISSIONS)) return true;
  return legacyFallback(user);
}

export function canManageOrgCarePrograms(user, hasAnyPermission, canStayOnModule) {
  if (typeof canStayOnModule === 'function') {
    return canStayOnModule('orgCarePrograms', LEGACY_CARE_PROGRAM_ROLES);
  }
  if (permissionOk(hasAnyPermission, ORG_CARE_PROGRAM_PERMISSIONS)) return true;
  return legacyFallback(user);
}

export function canViewBulkUploadLogs(user, hasAnyPermission, canStayOnModule) {
  if (typeof canStayOnModule === 'function') {
    return canStayOnModule('bulkUploadLogs', LEGACY_CARE_PROGRAM_ROLES);
  }
  if (permissionOk(hasAnyPermission, BULK_UPLOAD_LOGS_PERMISSIONS)) return true;
  return legacyFallback(user);
}
